import axios from "axios";
import { getAccessToken } from "../auth/msal/helpers";
import { User } from "../types";

const ENV = process.env.ENV || "prod";

const BASE_URLS = {
  local: "http://localhost:8080/local",
  dev: "https://yox5u6qgd9.execute-api.us-east-1.amazonaws.com/dev",
  qa: "https://7e102o8ue9.execute-api.us-east-1.amazonaws.com/qa",
  uat: "https://wlp4d35ldh.execute-api.us-east-1.amazonaws.com/uat/",
  prod: "https://skyh3buu7a.execute-api.us-east-1.amazonaws.com/prod/",
};

const api = axios.create({
  baseURL: BASE_URLS[ENV as keyof typeof BASE_URLS] || BASE_URLS.prod,
  headers: {
    "Content-Type": "application/json",
  },
});

/**
 * Fetches user data from the API
 * @param oid The unique oid returned from msal login
 * @returns A Promise that resolves to the user data
 */
export const getUser = async (oid: string) => {
  try {
    const token = await getAccessToken();
    const response = await api.post<any>(
      `/cactus-${ENV}-user-getUserData`,
      { oid },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data.user;
  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      console.log("Axios error:", error.response?.data);
    } else {
      console.log("General error:", error);
    }
    throw error;
  }
};
